import _ from "lodash";

const getOffsetFromParams = (params) => {
  const pagination = _.get(params, "pagination", {});
  const { perPage, page } = pagination;
  return perPage ? (page - 1) * perPage : 0;
};

const getLimitFromParams = (params) => {
  return _.get(params, "pagination.perPage", 10);
};

const makeParamsString = (params) => {
  let objectString = JSON.stringify(params.data).replace(/"(\w+)"\s*:/g, "$1:");
  return objectString.substring(1, objectString.length - 1).trim();
};

export { getOffsetFromParams, getLimitFromParams, makeParamsString };
